import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { Envelope } from '../../../types';
import { buildHeadersFromDocumentParams } from '../../documents/logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../../documents/types/DocumentParams';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const sendEnvelope = (
  constructGet: ConstructGet,
  envelopeId: string,
  documentParams: DocumentParams<'definition'>,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<Envelope> | undefined> =>
  constructGet<NonPaginatedResponse<Envelope>>(
    `${SIGNATURE_BASE_PATH}/envelope/${envelopeId}/send`,
    { headers: buildHeadersFromDocumentParams(documentParams), params },
    {
      transformerSet: TransformerSet.PreserveKeys,
      preventDefaultErrorToast: true,
    },
  );
